<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Test Package Table Data
    Loading...
  </div>
  <div v-else class="animated">
    <h3>Test Packages</h3>
    <v-client-table :columns="show_columns" :data="test_package_samples" :options="options" :theme="theme" id="sample-test-package-analyte-table" class="w-100">
      <span slot="test_package.name" slot-scope="{ row }">
        <existence-gate :entity="row" :levels="table_data.test_package" :field="'name'">
          <template #existing-content>
            <router-link :to="`/testpackages/${row.test_package.id}`">
              {{ row.test_package.name }}
            </router-link>
          </template>
        </existence-gate>
      </span>
      <span slot="name" slot-scope="{ row }">
        {{ row.name }}
      </span>
    </v-client-table>
  </div>
</template>

<script>
import Vue from "vue";
import ExistenceGate from "@/components/shared/ExistenceGate";
import { ClientTable } from "vue-tables-2";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { getEntityData, formatAnalyteName } from "@/shared/utils";

Vue.use(ClientTable);

const SampleRepository = LabRepositoryFactory.get("sample");

export default {
  name: "SampleTestPackageTable",
  components: {
    ClientTable,
    ExistenceGate,
  },
  props: {
    show_columns: {
      type: Array,
      default: () => [
        "test_package.name",
        "name",
        // "analyte",
        // "results",
      ],
    },
  },
  data() {
    return {
      loading: true,
      sample_id: this.$route.params.sample_id || null,
      test_package_samples: null,
      options: {
        headings: {
          "test_package.name": "Test Package",
          "name": "Package Sample Name",
        },
        sortable: ["test_package.name", "name"],
        filterable: ["test_package.name", "name"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll",
        },
      },
      theme: "bootstrap4",
      template: "default",
      table_data: {
        test_package: ["test_package"],
        //test_package_sample: [""],
      },
    };
  },
  methods: {
    getAnalyteData(analyte, data) {
      return getEntityData({
        entity: analyte,
        ...data,
      });
    },
    formatAnalyteName(analyte) {
      return formatAnalyteName(analyte);
    },
    async init() {
      const { data } = await SampleRepository.getTestPackageSamples(this.sample_id);
      this.test_package_samples = data;
      this.loading = false;
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
};
</script>
